export const cClasificacionArticulo = {
    normal: 5000,
    telefonoSerializableManual: 5001,
    productosInexistentesOtraBodega: 5002,
    productosInexistentesRequierecompra: 5003,
    vehiculo: 5004,

};

export const lstClasificacionArticulo = [
    {
        id: cClasificacionArticulo.normal,
        nombre: "Normal",
        cantidad: null
    },
    {
        id: cClasificacionArticulo.telefonoSerializableManual,
        nombre: "Serializable Manual",
        cantidad: 1
    },
    {
        id: cClasificacionArticulo.productosInexistentesOtraBodega,
        nombre: "Productos Inexistentes Otra Bodega",
        cantidad: 1
    },
    {
        id: cClasificacionArticulo.productosInexistentesRequierecompra,
        nombre: "Productos Inexistentes Requiere Compra",
        cantidad: 1
    },
    {
        id: cClasificacionArticulo.vehiculo,
        nombre: "Vehículo serializable manual",
        cantidad: 1
    }
];